import { Button } from '@heroui/react';
import { Link } from 'react-router-dom';

import { CloseIcon } from '@/components/icons/CloseIcon';
import { useCookieConsent } from '@/hooks/useCookieConsent';

const CookieBanner = () => {
    const { dismiss, isDismissed } = useCookieConsent();

    if (isDismissed) {
        return null;
    }

    return (
        <div
            aria-label="Cookie notice"
            className="fixed right-4 bottom-4 z-50 w-[calc(100%-2rem)] max-w-md"
            role="region"
        >
            <div className="relative rounded-2xl border border-white/10 bg-white/5 p-6 shadow-2xl ring-1 shadow-black/40 ring-indigo-400/20 backdrop-blur-md">
                <Button
                    aria-label="Close cookie notice"
                    className="focus-visible:ring-azerion-blue focus-visible:ring-offset-azerion-deep absolute top-3 right-3 min-w-0 rounded-md bg-transparent p-1 text-gray-300 hover:bg-white/10 hover:text-white focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
                    isIconOnly
                    onPress={dismiss}
                >
                    <CloseIcon className="h-5 w-5" />
                </Button>
                <h2 className="pr-8 text-xl font-bold text-white">Cookie settings</h2>
                <p className="mt-2 text-sm leading-relaxed text-gray-300">
                    By continuing to use this site, you accept our use of cookies. If you would like to find out more,
                    please read our{' '}
                    <Link
                        className="text-indigo-300 underline underline-offset-2 hover:text-indigo-200"
                        to="/website-privacy-notice"
                    >
                        privacy policy
                    </Link>
                    .
                </p>
            </div>
        </div>
    );
};

export { CookieBanner };
